<template>
  <Dialog
    :display="displayDeviceInfo"
    :title="title"
    :width="1000"
    :icon="'mdi-car'"
    @close="close"
  > 
    <v-row justify="center">
      <v-expansion-panels v-model="panel" accordion>
        <v-expansion-panel class="device-info-header" hide-actions>
          <v-expansion-panel-header color="#1C2849" class="white-text  pt-6">
            Category
            <template v-slot:actions>
              <v-icon color="white">mdi-chevron-down</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-expansion-panels accordion>
              <!-- GENERAL INFO -->
              <v-expansion-panel v-if="deviceInfoIsPopulated">
                <v-expansion-panel-header class="section-header">General</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">Manufacturer</v-col>
                    <v-col cols="10" class="value">{{ deviceInfo.manufacturer }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="label">Model</v-col>
                    <v-col cols="10" class="value">{{ deviceInfo.model }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="label">Revision</v-col>
                    <v-col cols="10" class="value">N/A</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="label">Serial</v-col>
                    <v-col cols="10" class="value">{{ deviceInfo.serial != '' ? deviceInfo.serial : 'N/A' }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="label">Firmware</v-col>
                    <v-col cols="10" class="value">{{ deviceInfo.firmwareVersion }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- ADAS INFO -->
              <v-expansion-panel v-if="checkForDeviceInfoComponent('adas')">
                <v-expansion-panel-header class="section-header">ADAS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-if="getDeviceInfoComponentDetails('adas', 'channel') != ''">
                    <v-col cols="7" class="label">Camera channel</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'channel') }} </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label-dark">Configuration</v-col>
                    <v-col cols="5"> </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Height of camera above ground:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.camToGround') }} mm</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Distance from camera to centre of windshield:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.camToCentre') }} mm left of centre</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Distance from camera to front bumper:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.camToFront') }} mm</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Vehicle width:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.vehicleWidth') }} mm</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Forward collision minimum speed:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.fcwMinSpeed') }} kph</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Forward collision time:</v-col>
                    <v-col cols="5"> {{ parseFloat(getDeviceInfoComponentDetails('adas', 'config.fcwTimeToCollision')) }} seconds</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Pedestrian collision minimum speed:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.pcwMinSpeed') }} kph</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Pedestrian collision maximum speed:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.pcwMaxSpeed') }} kph</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Pedestrian collision time:</v-col>
                    <v-col cols="5"> {{ parseFloat(getDeviceInfoComponentDetails('adas', 'config.pcwTimeToCollision')) }} seconds</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Lane departure minimum speed:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.ldwMinSpeed') }} kph</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Lane departure crossing distance:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.ldwCrossDist') }} mm</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Tailgating minimum speed:</v-col>
                    <v-col cols="5"> {{ getDeviceInfoComponentDetails('adas', 'config.fpwMinSpeed') }} kph</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="label">Tailgating collision time:</v-col>
                    <v-col cols="5"> {{ parseFloat(getDeviceInfoComponentDetails('adas', 'config.fpwTimeToCollision')) }} seconds</v-col>
                  </v-row>
                  <br>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead class="device-info-simple-table pt-3">
                        <tr>
                          <th class="text-left">
                            Alert
                          </th>
                          <th class="text-left">
                            Enabled
                          </th>
                          <th class="text-left">
                            Rate Limit (per hr)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in getDeviceInfoComponentDetails('adas', 'alerts')"
                          :key="item.name"
                        >
                          <td>{{ mapAdasType(item.type) }}</td>
                          <td>{{ JSON.parse(item.enabled) ? 'Yes' : 'No' }}</td>
                          <td>{{ item.rate }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('audio')">
                <v-expansion-panel-header class="section-header">Audio</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">In-cab volume:</v-col>
                    <v-col cols="10" class="value">{{ getDeviceInfoComponentDetails('audio', 'vol') }}%</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">DMS warnings:</v-col>
                    <v-col cols="10" class="value">{{ mapAudioSettings(getDeviceInfoComponentDetails('audio', 'dms.set')) }}</v-col>
                  </v-row>

                  <v-row v-if="getDeviceInfoComponentDetails('audio', 'adas.set') != ''">
                    <v-col cols="2" class="label">ADAS warnings:</v-col>
                    <v-col cols="10" class="value">{{ mapAudioSettings(getDeviceInfoComponentDetails('audio', 'adas.set')) }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('camera')">
                <v-expansion-panel-header class="section-header">Cameras</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead class="device-info-simple-table">
                        <tr>
                          <th class="text-left">
                            No.
                          </th>
                          <th class="text-left">
                            Name
                          </th>
                          <th class="text-left">
                            Enable
                          </th>
                          <th class="text-left">
                            Mirror
                          </th>
                          <th class="text-left">
                            Flip
                          </th>
                          <th class="text-left">
                            Main Qual
                          </th>
                          <th class="text-left">
                            Sub Qual
                          </th>
                          <th class="text-left">
                            Audio
                          </th>
                          <th class="text-left">
                            Stream Enable
                          </th>
                          <th class="text-left">
                            Disable on ACC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in getDeviceInfoComponentDetails('camera', 'channels')"
                          :key="item.id"
                        >
                          <td>{{ mapCameraValues(item.id) }}</td>
                          <td>{{ mapCameraValues(item.name) }}</td>
                          <td>{{ mapCameraValues(item.enabled) }}</td>
                          <td>{{ mapCameraValues(item.mirror) }}</td>
                          <td>{{ mapCameraValues(item.flip) }}</td>
                          <td>{{ mapCameraValues(item.mainQuality) }}</td>
                          <td>{{ mapCameraValues(item.subQuality) }}</td>
                          <td>{{ mapCameraValues(item.audioEnabled) }}</td>
                          <td>{{ mapCameraValues(item.streamEnabled) }}</td>
                          <td>{{ mapCameraValues(item.disableAccOff) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('dms')">
                <v-expansion-panel-header class="section-header">DMS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-if="getDeviceInfoComponentDetails('dms', 'channel') != ''">
                    <v-col cols="4" class="label">Camera channel:</v-col>
                    <v-col cols="8">{{ getDeviceInfoComponentDetails('dms', 'channel') }}</v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="4" class="label">Region of interest:</v-col>
                    <v-col cols="8">{{  }}</v-col>
                  </v-row> -->
                  <v-row v-if="getDeviceInfoComponentDetails('dms', 'config.driverPos') != ''">
                    <v-col cols="4" class="label">Driver position:</v-col>
                    <v-col cols="8">{{ getDeviceInfoComponentDetails('dms', 'config.driverPos') }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">Distraction left angle:</v-col>
                    <v-col cols="8">{{ getDeviceInfoComponentDetails('dms', 'config.distractLeftAngle') }} degrees</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">Distraction right angle:</v-col>
                    <v-col cols="8">{{ getDeviceInfoComponentDetails('dms', 'config.distractRightAngle') }} degrees</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">Distraction down angle:</v-col>
                    <v-col cols="8">{{ getDeviceInfoComponentDetails('dms', 'config.distractDownAngle') }} degrees</v-col>
                  </v-row>

                  <v-row>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead class="device-info-simple-table">
                          <tr>
                            <th class="text-left">
                              Alert
                            </th>
                            <th class="text-left">
                              Enabled
                            </th>
                            <th class="text-left">
                              Speed (kph)
                            </th>
                            <th class="text-left">
                              Duration (s)
                            </th>
                            <th class="text-left">
                              Rate Limit (per hr)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in getDeviceInfoComponentDetails('dms', 'alerts')"
                            :key="item.id"
                          >
                            <td>{{ mapDmsValues(item.type) }}</td>
                            <td>{{ mapDmsValues(item.enabled) }}</td>
                            <td>{{ item.speed }}</td>
                            <td>{{ item.duration }}</td>
                            <td>{{ item.rate }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('imu')">
                <v-expansion-panel-header class="section-header">IMU</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">
                      Vehicle type:
                    </v-col>
                    <v-col cols="10">
                      {{ mapImuValues(getDeviceInfoComponentDetails('imu', 'vehicleType')) }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">
                      Alerts enabled:
                    </v-col>
                    <v-col cols="10">
                      {{ mapImuValues(getDeviceInfoComponentDetails('imu', 'alertsEnabled')) }}
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('io')">
                <v-expansion-panel-header class="section-header">Inputs</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead class="device-info-simple-table">
                          <tr>
                            <th class="text-left">
                              No.
                            </th>
                            <th class="text-left">
                              Name
                            </th>
                            <th class="text-left">
                              Alert
                            </th>
                            <th class="text-left">
                              Active
                            </th>
                            <th class="text-left">
                              Guard (s)
                            </th>
                            <th class="text-left">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in getDeviceInfoComponentDetails('io', 'pins')"
                            :key="item.id"
                          >
                            <td>{{ item.id }}</td>  
                            <td>{{ item.name }}</td>
                            <td v-if="item.hasOwnProperty('alert')">{{ mapIoValues(item.alert) }}</td>
                            <td v-if="item.hasOwnProperty('trigger')">{{ mapIoValues(item.trigger) }}</td>
                            <td v-if="item.hasOwnProperty('guard')">{{ item.guard }}</td>
                            <td v-if="item.hasOwnProperty('action') && item.action.type == 'none'">-</td>
                            <td v-if="item.hasOwnProperty('action') && (item.action.type == 'link_to_cam' || item.action.type == 'disable_cam')">
                              <span class="display-block">{{ mapIoValues(item.action.type) }}</span>
                              <span v-for="cam in item.action.context.cameras" :key="cam">
                                {{ cam }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('mcu')">
                <v-expansion-panel-header class="section-header">Microcontroller</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">
                      Firmware:
                    </v-col>
                    <v-col cols="10">
                      {{ getDeviceInfoComponentDetails('mcu', 'fwVersion') }}
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('modem')">
                <v-expansion-panel-header class="section-header">Modem</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">Manufacturer:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'manufacturer') }}</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">Model:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'model') }}</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">Revision:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'revision') != '' ? getDeviceInfoComponentDetails('modem', 'revision') : 'N/A' }}</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">IMEI:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'imei') }}</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="2" class="label">ICCID:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'iccid') }}</v-col>
                  </v-row>

                   <v-row>
                    <v-col cols="2" class="label">APN:</v-col>
                    <v-col cols="10">{{ getDeviceInfoComponentDetails('modem', 'apn') }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('power')">
                <v-expansion-panel-header class="section-header">Power</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="3" class="label">Power down delay:</v-col>
                    <v-col cols="9">
                      {{ getDeviceInfoComponentDetails('power', 'pdd') }} 
                      <span v-if="getDeviceInfoComponentDetails('power', 'pdd') > 1">minutes</span> 
                      <span v-else>minute</span>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3" class="label">Low voltage power down:</v-col>
                    <v-col cols="9">{{ Math.round(getDeviceInfoComponentDetails('power', 'lvt')) }} volts</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3" class="label">Daily reboot enabled:</v-col>
                    <v-col cols="9">{{ JSON.parse(getDeviceInfoComponentDetails('power', 'dailyReboot')) ? 'Yes' : 'No' }}</v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3" class="label">Daily reboot time:</v-col>
                    <v-col cols="9">{{ formatTime24(getDeviceInfoComponentDetails('power', 'rebootTime')) }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('recording')">
                <v-expansion-panel-header class="section-header">Recording</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="1" class="label">Codec:</v-col>
                    <v-col cols="11">{{ getDeviceInfoComponentDetails('recording', 'encoderType') }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('speeding')">
                <v-expansion-panel-header class="section-header">Speeding</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="2" class="label">Alerts enabled:</v-col>
                    <v-col cols="10">{{ JSON.parse(getDeviceInfoComponentDetails('speeding', 'alertsEnabled')) ? 'Yes' : 'No' }}</v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('storage')">
                <v-expansion-panel-header class="section-header">Storage</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-for="disk in getDeviceInfoComponentDetails('storage', 'devices')" :key="disk.id">
                    <v-row>
                      <v-col cols="12">
                        <h3>
                          {{ mapStorageValues(disk.class) }}
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="label">
                        Medium:
                      </v-col>
                      <v-col cols="10">
                        {{ mapStorageValues(disk.medium) }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="label">
                        Model:
                      </v-col>
                      <v-col cols="10">
                        {{ disk.model }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="label">
                        Capacity:
                      </v-col>
                      <v-col cols="10">
                        {{ formatStorageCapacity(disk.capacity) }}
                      </v-col>
                    </v-row>
                  </div>
                  
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="checkForDeviceInfoComponent('timeConfig')">
                <v-expansion-panel-header class="section-header">Time Settings</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="4" class="label">
                      Time zone offset:
                    </v-col>
                    <v-col cols="8">
                      {{ formatOffset(getDeviceInfoComponentDetails('timeConfig', 'tzOffset')) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">
                      DST Offset:
                    </v-col>
                    <v-col cols="8">
                      {{ formatOffset(getDeviceInfoComponentDetails('timeConfig', 'dst.offset')) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">
                      Daylight saving time enabled:
                    </v-col>
                    <v-col cols="8">
                     {{ JSON.parse(getDeviceInfoComponentDetails('timeConfig', 'dst.enabled')) ? 'Yes' : 'No' }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">
                      Daylight saving starts on:
                    </v-col>
                    <v-col cols="8">
                      {{ formatDstRule(getDeviceInfoComponentDetails('timeConfig', 'dst.dstStart')) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="label">
                      Daylight saving ends on:
                    </v-col>
                    <v-col cols="8">
                      {{ formatDstRule(getDeviceInfoComponentDetails('timeConfig', 'dst.dstEnd')) }}
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </Dialog>
</template>

<script>

  import { GetOrgDeviceInfo } from '@/services/API.js'
  
  import Dialog from '@/components/general/Dialog.vue';

  // logger
  import { Logger } from "aws-amplify"
  const logger = new Logger("Device Info")

  export default {
    name: 'DeviceInfo',

    components: {
      Dialog
    },

    props: {
      displayDeviceInfo: {
        type: Boolean,
        required: true
      },

      vehicle: {
        type: Object,
        required: false,
        default: () => {} 
      },

      vehicleName: {
        type: String,
        required: false,
        default: ''
      },

      deviceId: {
        type: String, 
        required: true
      },

      org: {
        type: String, 
        required: true
      }
    },

    data() {
      return {
        deviceInfo: {},
        
        loading: false,

        panel: 0
      }
    },

    computed: {
      title() {
        if (!this.vehicle) return this.vehicleName

        let deviceInfo = {}
        let installTag = ''

        if(this.vehicle) {
          deviceInfo = this.vehicle.devices.find(device => device.is_defaultdevice == true || device.is_default_device == true || device.is_default_device == 'true')
        }
        
        if(deviceInfo.hasOwnProperty('installation_tag')) {
          installTag = `(${deviceInfo.installation_tag})`
        }

        if(this.vehicleName == '') {
          return `${this.vehicle.vehicle_name} ${installTag}`
        }
        else {
          return this.vehicleName
        }
      },

      deviceInfoIsPopulated() {
        return Object.keys(this.deviceInfo).length > 0
      }
    },

    mounted() {
      this.getDeviceInfo()
    },

    methods: {
      close() {
        this.$emit('close')
      },

      async getDeviceInfo() {
        this.deviceInfo = {}
        this.loading = true

        if(!this.deviceId || this.deviceId == '') return

        const deviceInfo = await GetOrgDeviceInfo(this.org, this.deviceId)


        if(Object.hasOwn(deviceInfo, 'components') && deviceInfo.components.length > 0) {
          this.deviceInfo = deviceInfo
          logger.info(this.deviceInfo)
        }

        this.loading = false
        
      },

      checkForDeviceInfoComponent(component) {
        if(!this.deviceInfo.hasOwnProperty('components')) return false
        const components = this.deviceInfo.components
        const requestedComponentInfo = components.filter(list => list.type == component)
        
        return requestedComponentInfo.length > 0 ? true : false
      },

      getDeviceInfoComponentDetails(component, attributePath) {
        if (!this.checkForDeviceInfoComponent(component)) return ''

        const componentDetails = this.deviceInfo.components
          .find(item => item.type === component)

        if (!componentDetails || !attributePath) return ''

        return attributePath
          .split('.')
          .reduce((obj, key) => obj?.[key], componentDetails) ?? ''
      },

      mapAudioSettings(str) {
        const map = {
          'tone': 'Tone only',
          'voice': 'Voice only',
          'toneVoice': 'Tone and voice'
        }

        return map.hasOwnProperty(str) ? map[str] : str
      },

      mapCameraValues(str) {
        const map = {
          'false': 'No',
          'true': 'Yes',
          'high': 'High',
          'normal': 'Normal'
        }

        return map.hasOwnProperty(str) ? map[str] : str
      },

      mapDmsValues(str) {
        const map = {
          'phone': 'Phone',
          'eyesClosed': 'Eyes Closed',
          'yawn': 'Yawn',
          'smoking': 'Smoking',
          'distractLeft': 'Distraction Left',
          'distractRight': 'Distraction Right',
          'distractDown': 'Distraction Down',
          'occlusion': 'Occlusion',
          'false': 'No',
          'true': 'Yes',
        }
        return map.hasOwnProperty(str) ? map[str] : '-'
      },

      mapImuValues(str) {
        const map = {
          'true': 'Yes',
          'false': 'No',
          0: 'Heavy Truck',
          1: 'Light Truck',
          2: 'Heavy Van',
          3: 'Light Van',
          4: 'Car',
          5: 'Bus/Coach'
        }

        return map.hasOwnProperty(str) ? map[str] : str
      },

      mapIoValues(str) {
        const map = {
          'l': 'Low',
          'h': 'High',
          'true': 'Yes',
          'false': 'No',
          'link_to_cam': 'Link to camera',
          'disable_cam': 'Disable cameras'
        }
        return map.hasOwnProperty(str) ? map[str] : str
      },

      mapStorageValues(str) {
        const map = {
          'hdd': 'Hard disk',
          'primary': 'Primary storage',
          'secondary': 'Secondary storage',
          'sd': 'SD card'
        }
        return map.hasOwnProperty(str) ? map[str] : str
      },

      formatStorageCapacity(size) {
        const formatNumberString = (str) => {
          return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
        const freeTotalSplit = size.split('/')
        
        return `${formatNumberString(freeTotalSplit[1])} MB total / ${formatNumberString(freeTotalSplit[0])} MB used`
      },

      mmToInches(mm) {
        return mm / 25.4;
      },

      mmToFeet(mm) {
        return mm / 304.8;
      },

      mmToFeetInches(mm) {
        const totalInches = mm / 25.4;
        const feet = Math.floor(totalInches / 12);
        const inches = totalInches % 12;

        return { feet, inches };
      },

      kphToMph(kph) {
        return kph * 0.621371;
      },

      formatDstRule(rule) {
        const months = [
          "January", "February", "March", "April",
          "May", "June", "July", "August",
          "September", "October", "November", "December"
        ];

        const occurrenceMap = {
          first: "First",
          second: "Second",
          third: "Third",
          fourth: "Fourth",
          last: "Last"
        };

        const hour = parseInt(rule.hour, 10);

        // Convert to 12-hour format
        const period = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;

        return `${occurrenceMap[rule.occurrence]} Sunday of ${months[rule.month]} at ${hour12}:00 ${period}`;
      },

      formatOffset(offsetStr) {
        const minutes = parseInt(offsetStr, 10);

        if (isNaN(minutes) || minutes === 0) {
          return "0 minutes";
        }

        const sign = minutes > 0 ? "+" : "-";
        const absMinutes = Math.abs(minutes);

        const hours = Math.floor(absMinutes / 60);
        const remainingMinutes = absMinutes % 60;

        let parts = [];

        if (hours > 0) {
          parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
        }

        if (remainingMinutes > 0) {
          parts.push(`${remainingMinutes} minute${remainingMinutes !== 1 ? "s" : ""}`);
        }

        return `${sign}${parts.join(" ")}`;
      },

      formatTime24(rebootTime) {
        const totalMinutes = parseInt(rebootTime, 10);

        if (isNaN(totalMinutes) || totalMinutes < 0) {
          return "Invalid time";
        }

        const hours = Math.floor(totalMinutes / 60) % 24;
        const minutes = totalMinutes % 60;

        const pad = (n) => String(n).padStart(2, "0");

        return `${pad(hours)}:${pad(minutes)}`;
      },

      mapAdasType(alert) {
        const map = {
          'fcw': 'Forward Collision',
          'pcw': 'Pedestrian Collision',
          'ldw': 'Lane Departure',
          'fpw': 'Tailgating'
        }

        return map.hasOwnProperty(alert) ? map[alert] : alert
      }
    }
  }
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.label {
  color: #4372B7;
}
.label-dark {
  color: #25497e;
  font-weight: bold;
}
.device-info-simple-table {
  background: grey !important;
  th {
    color: white !important;
  }
}
.white-text {
  color: white !important
}
.section-header {
  color: #1C2849 !important;
  font-weight: bold;
  font-size: 18px;
}
::v-deep(.v-row),
::v-deep(.v-col) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>